import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { Row, Col } from 'grab-ui';

import CDatePicker from 'components/custom/CDatePicker';

import './SchedulePage.scss';

type Props = {
  country: Object;
  targetUserType: string;
  campaign: Object;
  countries: Object;
  campaign: Object;
  formData: Object;
  handleFormDataChange: Function;
  validateFormRef: Function,
  error: any,
};


export class SchedulePage extends React.Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.props.validateFormRef(this.validateForm);

    this.state = {
      error: this.props.error,
    };
  }

  componentDidMount() {
    const { formData, campaign } = this.props;
    if (_.isEmpty(formData.scheduleTime)) {
      const defaultTime = _.get(campaign, 'startTime');
      this.props.handleFormDataChange(
        { scheduleTime: moment(defaultTime).toDate().toISOString() }
      );
    }
  }


  validateForm = () => {
    const { formData } = this.props;
    let scheduleTimeErrors = [];
    if (_.isEmpty(_.get(formData, 'scheduleTime'))) {
      scheduleTimeErrors = ["Schedule can't be blank"];
    }

    return {
      scheduleTimeErrors,
    };
  };

  handleDateChange = (event: any, data: any) => {
    this.props.handleFormDataChange(
      { scheduleTime: moment(data.value).toDate().toISOString() }
    );
  };

  handleControlBlur = () => {
    const error = this.validateForm();
    this.setState({ error });
  };

  render() {
    const { formData, campaign } = this.props;

    const campaignStartDate = _.get(campaign, 'start');
    const minDate = _.isEmpty(campaignStartDate) ? null : moment(campaignStartDate);

    const campaignEndDate = _.get(campaign, 'end');
    const maxDate = _.isEmpty(campaignEndDate) ? null : moment(campaignEndDate);

    const scheduleTime = _.get(formData, 'scheduleTime');
    const startDate = _.isEmpty(scheduleTime) ? null : moment(scheduleTime);

    const scheduleTimeErrors = _.get(this.state, 'error.scheduleTimeErrors');

    return (
      <div className={'schedule-wrapper'}>
        <Row gutter={24}>
          <Col className={'schedule-header'}>
            <h3 style={{ fontWeight: 500 }}>Set-up Schedule</h3>
            {!_.isEmpty(scheduleTimeErrors) &&
              <div className="ui negative message">
                <div className="header"><span className="validation-icon" />
                  {_.map(scheduleTimeErrors, (error) => <p>{error}</p>)}
                </div>
              </div>
            }
          </Col>
          <Col span={12}>
            <CDatePicker
              required
              showIcon
              selectsStart
              label={'Date'}
              selected={startDate}
              startDate={startDate}
              minDate={minDate}
              maxDate={maxDate}
              handleInputChange={this.handleDateChange}
              onBlur={this.handleControlBlur}
            />
          </Col>
          <Col span={12}>
            <CDatePicker
              required
              selectsStart
              showTimeSelect
              showTimeSelectOnly
              label={'Time'}
              selected={startDate}
              startDate={startDate}
              minDate={minDate}
              maxDate={maxDate}
              handleInputChange={this.handleDateChange}
              onBlur={this.handleControlBlur}
              timeFormat="HH:mm"
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default SchedulePage;
